import AgoraRTC, {IAgoraRTCClient, ILocalAudioTrack, ILocalTrack, ILocalVideoTrack, UID} from "agora-rtc-sdk-ng";
import {AgoraCodecs} from "@share/web-conferences/enums/AgoraCodecs";
import {AgoraCredentials} from "@api/models/web-conferences/AgoraCredentials";
import {AgoraVideoEncoding} from "@share/web-conferences/enums/AgoraVideoEncoding";
import {TracksManagerInterface} from "@share/web-conferences/interfaces/TracksManagerInterface";
import {AgoraScreenShareInterface} from "@share/web-conferences/interfaces/AgoraScreenShareInterface";
import {Store} from "vuex";
import {defineMode} from "@share/web-conferences/helpers/AgoraClientMode";
import {WebConferenceTypes} from "@share/web-conferences/enums/WebConferenceTypes";

export class AgoraScreenShare implements AgoraScreenShareInterface {
    client: IAgoraRTCClient;
    joined = false;
    isSharing = false;
    uid: UID = '';

    constructor(
        private readonly tracksManager: TracksManagerInterface,
        private readonly store: Store<any>,
        type: WebConferenceTypes
    ) {
        this.client = AgoraRTC.createClient({
            mode: defineMode(type),
            codec: AgoraCodecs.Vp8,
            role: 'host'
        });
        // this.client.enableDualStream();
    }

    async join(credentials: AgoraCredentials) {
        try {
            this.uid = await this.client.join(credentials.appId, credentials.channelId, credentials.screenSharingToken as string, credentials.screenSharingUserId);
            this.joined = true;
        }
        catch (e) {
            this.store.dispatch('reportError', e);
            this.joined = false;
        }

        return this.joined;
    }

    async joinAndCreateStream(credentials: AgoraCredentials) {
        console.log('credentials', credentials);
        await this.join(credentials);
        if (this.joined) {
            return await this.createStream();
        }
        return false;
    }

    async createStream(sharingTracks: ILocalVideoTrack | [ILocalVideoTrack, ILocalAudioTrack] | null = null) {
        try {
            const tracks = sharingTracks ?? await AgoraRTC.createScreenVideoTrack({
                encoderConfig: AgoraVideoEncoding.Ve1080p1,
                screenSourceType: 'screen'
            }, "auto");

            const videoTrack: ILocalVideoTrack = Array.isArray(tracks) ? tracks[0] : tracks;
            const audioTrack: ILocalAudioTrack | undefined = Array.isArray(tracks) ? tracks[1] : undefined;
            const toPublish: ILocalTrack[] = [audioTrack as ILocalAudioTrack, videoTrack as ILocalVideoTrack].filter(item => item);
            await this.client.publish(toPublish);

            await this.tracksManager.update({
                uid: this.uid,
                isLocal: false,
                isScreenShare: true,
                video: videoTrack,
                audio: audioTrack
            });

            videoTrack.on('track-ended', () => {
               this.leave();
            });

            this.isSharing = true;

            return true;
        }
        catch (e) {
            this.store.dispatch('reportError', e);
            await this.leave();
        }

        return false;
    }

    async leave() {
        console.log('share client leaving');
        if (this.joined) {
            try {
                await this.tracksManager.remove(this.uid, true);
                await this.client.leave();
                this.joined = false;
                this.isSharing = false;
            } catch (e) {
                this.store.dispatch('reportError', e);
            }
        }
    }
}
